import Modal from 'developer_components/newModal';

function Contacts($element, options = {}) {
    Modal.call(this, $element, options);

    this.$phones = this.$element.querySelector('.js-contacts-phones');

    this.setPhones(this.options?.phones);
}

Contacts.prototype = Object.create(Modal.prototype);
Object.defineProperty(Contacts.prototype, 'constructor', {
    value: Contacts,
    enumerable: false,
    writable: true,
});

Contacts.prototype.setPhones = function(phones = []) {
    for (const phone of phones) {
        this.$phones.insertAdjacentHTML('beforeend', `
            <div class="phone">
                <span class="phone__title">${phone.title}</span>
                <a href="tel:${phone.tel}">${phone.phone}</a>
            </div>
        `);
    }
}

Contacts.make = function(options) {
    const $modal = Modal.createFromHTML(`
        <div class="Contacts__header">
            <div class="Contacts__close js-modalClose">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM16.307 7.69289C16.6976 8.08342 16.6976 8.71658 16.307 9.10711L13.4142 12L16.307 14.8929C16.6976 15.2834 16.6976 15.9166 16.307 16.3071C15.9165 16.6976 15.2834 16.6976 14.8928 16.3071L11.9999 13.4142L9.10705 16.3071C8.71653 16.6976 8.08336 16.6976 7.69284 16.3071C7.30231 15.9166 7.30231 15.2834 7.69284 14.8929L10.5857 12L7.69284 9.10711C7.30231 8.71658 7.30231 8.08342 7.69284 7.69289C8.08336 7.30237 8.71653 7.30237 9.10705 7.69289L11.9999 10.5858L14.8928 7.69289C15.2834 7.30237 15.9165 7.30237 16.307 7.69289Z" fill="#D4D2D8"/>
                </svg>
            </div>
        </div>
        <div class="Contacts__content">
            <span class="Contacts__title">Подбор для вас</span>
            <div class="Contacts__phones js-contacts-phones"></div>
        </div>
    `, { id: 'contacts' });

    return new Contacts($modal, options);
}

export default Contacts;
